module.exports = __webpack_public_path__ + "static/media/sg.6ae2dc5b.svg";